/**
 * Proto相关代码
 */
export enum FunCode {
    QueryCommonReq = 17104897, // 通用查询请求(17104897)
    QueryCommonRsp = 17104901, // 通用查询应答(17104901)
    QueryCommonSenReq = 17104952, // 加密信息通用查询请求
    QueryCommonSenRsp = 17104953, // 加密信息通用查询应答

    LoginReq = 65537, // 用户登录请求
    LoginRsp = 65538, // 用户登录应答
    LogoutReq = 65539, // 用户登出请求
    LogoutRsp = 65540, // 用户登出应答
    TokenCheckReq = 65541, // 用户令牌校验请求
    TokenCheckRsp = 65542, // 用户令牌校验应答
    ModifyPwdReq = 65543, // 修改账户密码请求
    ModifyPwdRsp = 65544, // 修改账户密码应答
    InvestorDelReq = 1900553, // 投资者销户申请请求
    InvestorDelRsp = 1900554, // 投资者销户申请请求响应

    DealerHeadReq = 1900635, // 交易商头像请求
    DealerHeadRsp = 1900636, // 交易商头像应答

    t2bBankSignReq = 589825, // 签约请求
    t2bBankSignRsp = 589826, // 签约应答
    t2bBankCancelSignReq = 589827, // 解约请求
    t2bBankCancelSignRsp = 589828, // 解约应答
    t2bBankWithdrawReq = 589837, // 出金请求
    t2bBankWithdrawRsp = 589838, // 出金应答
    t2bBankDepositReq = 589843, // 入金请求
    t2bBankDepositRsp = 589844,   //入金应答
    AccountFundInfoReq = 262150,   /// 账户资金信息请求(0, 4, 6)
    AccountFundInfoRsp = 262151,  /// 账户资金信息响应(0, 4, 7)
    t2bSMSVerificationCodeReq = 589853,    // 银行获取手机验证码请求
    t2bSMSVerificationCodeRsp = 589854,   // 银行获取手机验证码应答

    UserReceiveInfoReq = 1900545, // 新增修改收货地址请求
    UserReceiveInfoRsp = 1900546, // 新增修改收货地址请求响应
    DelUserReceiveInfoReq = 1900547, // 删除收货地址请求
    DelUserReceiveInfoRsp = 1900548, // 删除收货地址请求响应
    UserReceiveIsDefaultReq = 1900570, // 设置默认收货地址请求
    UserReceiveIsDefaultRsp = 1900571, // 设置默认收货地址应答

    UserReceiptInfoReq = 1900549, // 新增修改用户发票信息请求
    UserReceiptInfoRsp = 1900550, // 新增修改用户发票信息响应
    DelUserReceiptInfoReq = 1900551, // 删除用户发票信息请求
    DelUserReceiptInfoRsp = 1900552, // 删除用户发票信息请求响应

    // 交易通知
    MoneyChangedNotify = 131076, // 资金变化通知
    UserChangeNtf = 131106,    /// 用户变更通知(0, 2, 34)
    WRTradeDealedNtf = 131110, // 仓单贸易成交通知
    ListingOrderChangeNtf = 131176, // 挂牌委托变更广播通知
    OrderDealedNtf = 131081, // 委托单成交通知
    MarketStatusChangeNtf = 131089, // 市场状态变更通知
    PosChangedNtf = 131075, // 头寸变化通知
    RiskControlNtf = 131086, // 风控通知
    RiskToWebNtf = 131139, // 风控消息管理端通知客户端
    OrderSuccessedNtf = 131152, /// 委托单委托成功通知(0, 2, 80)
    OrderCanceledNtf = 131084, /// 委托单撤单通知(0, 2, 12)
    
    // 行情内容
    QuoteBeat = 0x12, // 心跳
    QuoteSubscribeReq = 0x20, // 实时行情订阅请求
    QuoteSubscribeRsp = 0x21, // 实时行情订阅响应
    QueryQuoteReq = 0x22, // 盘面查询请求
    QueryQuoteRsp = 0x23, // 盘面查询应答

    THJRedPacketLotteryReq = 1441863, // 铁合金抽奖接口请求
    THJRedPacketLotteryRsp = 1441864, // 铁合金抽奖接口响应

    SpotPresaleDestingOrderReq = 1441849,             /// 铁合金现货预售摘牌接口请求
    SpotPresaleDestingOrderRsp = 1441850,             /// 铁合金现货预售摘牌接口应答
    SpotPresaleDeliveryConfirmReq = 1441861,          /// 铁合金现货预售交收确认接口请求
    SpotPresaleDeliveryConfirmRsp = 1441862,          /// 铁合金现货预售交收确认接口应答
    SpotPresaleBreachOfContractApplyReq = 1441855,	  /// 铁合金现货预售违约申请接口请求(0, 22, 63)
    SpotPresaleBreachOfContractApplyRsp = 1441856,	  /// 铁合金现货预售违约申请接口应答(0, 22, 64)
    SpotPresaleBreachOfContractConfirmReq = 1441857,  /// 铁合金现货预售违约确认接口请求
    SpotPresaleBreachOfContractConfirmRsp = 1441858,  /// 铁合金现货预售违约确认接口应答
    SpotPresalePlaymentReq = 1441853,                 /// 铁合金现货预售付款处理接口请求(0, 22, 61)
    SpotPresalePlaymentRsp = 1441854,           	  /// 铁合金现货预售付款处理接口应答(0, 22, 62)
    WRListingCancelOrderReq = 1441796,                /// 挂牌撤单请求
    WRListingCancelOrderRsp = 1441797,                /// 挂牌撤单应答
    WROutApplyReq = 1900657,                          /// 仓单出库申请
    WROutApplyRsp = 1900658,                          /// 仓单出库申请响应
    HdWROrderReq = 1441807,                           /// 持仓单挂牌请求
    HdWROrderRsp = 1441808,                           /// 持仓单挂牌应答
    HdWRDealOrderReq = 1441809,                       /// 持仓单摘牌请求
    HdWRDealOrderRsp = 1441810,                       /// 持仓单摘牌应答
    SpotPresaleTransferListingReq = 1441859,          /// 铁合金现货预售转让挂牌接口请求(0, 22, 67)
    SpotPresaleTransferListingRsp = 1441860,          /// 铁合金现货预售转让挂牌接口响应(0, 22, 68)
    SpotPresaleTransferCancelReq = 1441867,           /// 铁合金现货预售转让撤销接口请求(0, 22, 75)
    SpotPresaleTransferCancelRsp = 1441868,           /// 铁合金现货预售转让撤销接口响应(0, 22, 76)
    SpotPresaleTransferDestingReq = 1441869,          /// 铁合金现货预售转让摘牌接口请求(0, 22, 77)
    SpotPresaleTransferDestingRsp = 1441870,          /// 铁合金现货预售转让摘牌接口响应(0, 22, 78)
    THJProfitDrawApplyReq = 1441871,                  /// 铁合金收益支取申请接口请求(0, 22, 79)
    THJProfitDrawApplyRsp = 1441872,                  /// 铁合金收益支取申请接口响应(0, 22, 80)

    SpotPresalePointPriceReq = 1441877, // 铁合金预售点价请求
    SpotPresalePointPriceRsp = 1441878, // 铁合金预售点价响应
    OrderReq = 196609,  // 交易委托请求(0, 3, 1)
    OrderRsp = 196610,  // 交易委托应答(0, 3, 2)
    CancelOrderReq = 196611,  // 撤单请求(0, 3, 3)
    CancelOrderRsp = 196612,  // 撤单应答(0, 3, 4)
    HolderCloseReq = 196713,  // 按单平仓请求(196713)
    HolderCloseRsp = 196714,  // 按单平仓应答(196714)

    DeliveryOrderReq = 393217, // 交割申报请求
    DeliveryOrderRsp = 393218, // 交割申报应答
    MakeUpDepositReq = 196715, // 补足定金请求
    MakeUpDepositRsp = 196716, // 补足定金应答
    HoldAppendDepositReq = 196719, // 持仓追加定金接口请求
    HoldAppendDepositRsp = 196720, // 持仓追加定金接口应答
    OfflineDeliveryReq = 196723,   // 线下交收申请请求
    OfflineDeliveryRsp = 196724,   // 线下交收申请请求

    PerformanceContractedApplyReq = 1310729, // 违约申请请求
    PerformanceContractedApplyRsp = 1310730, // 违约申请应答
    PerformanceDelayApplyReq = 1310725, // 延期申请请求
    PerformanceDelayApplyRsp = 1310726, // 延期申请应答
    PerformanceManualConfirmReq = 1310723, // 履约手动确认请求
    PerformanceManualConfirmRsp = 1310724, // 履约手动确认应答
    PerformanceModifyContactReq = 1310735, // 履约修改联络信息请求
    PerformanceModifyContactRsp = 1310736, // 履约修改联络信息回应

    SupplementDepositReq = 196731, // 补充定金接口请求
    SupplementDepositRsp = 196732, // 补充定金接口响应
    RefundedDepositReq = 196733, // 退返定金接口请求
    RefundedDepositRsp = 196734, // 退返定金接口响应
    MarketOrderDeliveryApplyReq = 196739, // 按单做市交收申请接口请求
    MarketOrderDeliveryApplyRsp = 196740, // 按单做市交收申请接口响应
    DeliveryClientOperatorReq = 196743, // 交收终端操作接口请求
    DeliveryClientOperatorRsp = 196744, // 交收终端操作接口响应
    OfflineDeliveryApplyCancelOrderReq = 196745,    // MAKE_FID(0, 3, 137)  线下交收申请撤销接口请求(196745)
    OfflineDeliveryApplyCancelOrderRsp = 196746,   // MAKE_FID(0, 3, 138) // 线下交收申请撤销接口响应(196746)

    HolderTransferApplyReq = 196751, // 持仓过户申请接口请求
    HolderTransferApplyRsp = 196752, // 持仓过户申请接口响应
    HolderTransferConfirmReq = 196753, // 持仓过户确认接口请求
    HolderTransferConfirmRsp = 196754, // 持仓过户确认接口响应

	YJF_GetWithholdSignInSMSVCodeReq = 2621451,  /// 云缴费获取代扣签约短信验证码请求(0, 40, 11)
	YJF_GetWithholdSignInSMSVCodeRsp = 2621452,  /// 云缴费获取代扣签约短信验证码响应(0, 40, 12)
	YJF_WithholdSignInSMSReq = 2621453,          /// 云缴费代扣签约请求(0, 40, 13)
	YJF_WithholdSignInSMSRsp = 2621454,          /// 云缴费代扣签约响应(0, 40, 14)
	YJF_WithholdSignOutReq = 2621455,            /// 云缴费代扣解约请求(0, 40, 15)
	YJF_WithholdSignOutRsp = 2621456,            /// 云缴费代扣解约响应(0, 40, 16)
	YJF_WithholdInApplyReq = 2621457,            /// 云缴费代扣入金申请请求(0, 40, 17)
	YJF_WithholdInApplyRsp = 2621458,            /// 云缴费代扣入金申请响应(0, 40, 18)

    ModifyOrderReq = 196761,   // MAKE_FID(0, 3, 153) 修改订单接口请求(196761)
    ModifyOrderRsp = 196762,   // MAKE_FID(0, 3, 154) 修改订单接口响应(196762)

    DepositTransferOperateReq = 196763,   // 定金转让持仓操作请求
    DepositTransferOperateRsp = 196764,   // 定金转让持仓操作响应

    GoodsInventoryApplyAuditReq = 196769, // 用户出入库审核请求
    GoodsInventoryApplyAuditRsp = 196770, // 用户出入库审核应答

    GoodsInventoryApplyReq = 196767, // 用户出入库申请请求
    GoodsInventoryApplyRsp = 196768, // 用户出入库申请应答
} 
